import script from "./component-form-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./component-form-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./component-form-drawer.vue?vue&type=style&index=0&id=d30fc5c8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d30fc5c8"]])

export default __exports__